/* NEONA Influencer Landingpage — shared interactions for all sections.
   Linked (deferred) by every section; init is guarded so it runs only once. */
(function () {
  if (window.__ninfInit) return;
  window.__ninfInit = true;

  function init() {
    var roots = function () { return document.querySelectorAll('.ninf'); };

    /* ---- scroll reveal ---- */
    var reveals = document.querySelectorAll('.ninf .reveal');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      // safety: never leave content hidden
      setTimeout(function () { reveals.forEach(function (el) { el.classList.add('is-in'); }); }, 1600);
    }

    /* ---- copy discount code (event delegation) ---- */
    document.addEventListener('click', function (ev) {
      var code = ev.target.closest && ev.target.closest('.ninf .lp-code');
      if (!code) return;
      var val = code.getAttribute('data-code') || '';
      try { navigator.clipboard && navigator.clipboard.writeText(val); } catch (e) {}
      code.classList.add('is-copied');
      var hint = code.querySelector('.lp-code-hint');
      if (hint) { if (!hint.dataset.label) hint.dataset.label = hint.textContent; hint.textContent = 'Kopiert ✓'; }
      clearTimeout(code.__t);
      code.__t = setTimeout(function () {
        code.classList.remove('is-copied');
        if (hint && hint.dataset.label) hint.textContent = hint.dataset.label;
      }, 1600);
    });

    /* ---- FAQ accordion (event delegation) ---- */
    document.addEventListener('click', function (ev) {
      var q = ev.target.closest && ev.target.closest('.ninf .lp-faq-q');
      if (!q) return;
      var item = q.closest('.lp-faq-item');
      var list = q.closest('.lp-faq-list');
      var isOpen = item.classList.contains('is-open');
      if (list) list.querySelectorAll('.lp-faq-item.is-open').forEach(function (i) {
        i.classList.remove('is-open');
        var b = i.querySelector('.lp-faq-q'); if (b) b.setAttribute('aria-expanded', 'false');
        var m = i.querySelector('.lp-faq-mark'); if (m) m.textContent = '+';
      });
      if (!isOpen) {
        item.classList.add('is-open');
        q.setAttribute('aria-expanded', 'true');
        var mk = item.querySelector('.lp-faq-mark'); if (mk) mk.textContent = '–';
      }
    });

    /* ---- before/after slider ---- */
    document.querySelectorAll('.ninf .lp-ba').forEach(function (ba) {
      if (ba.__bound) return; ba.__bound = true;
      var clip = ba.querySelector('.lp-ba-clip');
      var handle = ba.querySelector('.lp-ba-handle');
      var dragging = false;
      function setFromX(clientX) {
        var r = ba.getBoundingClientRect();
        var p = Math.max(2, Math.min(98, (clientX - r.left) / r.width * 100));
        if (clip) clip.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
        if (handle) handle.style.left = p + '%';
        ba.setAttribute('aria-valuenow', Math.round(p));
      }
      function pt(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
      function start(e) { dragging = true; setFromX(pt(e)); }
      ba.addEventListener('mousedown', start);
      ba.addEventListener('touchstart', start, { passive: true });
      window.addEventListener('mousemove', function (e) { if (dragging) setFromX(pt(e)); });
      window.addEventListener('touchmove', function (e) { if (dragging) setFromX(pt(e)); }, { passive: true });
      window.addEventListener('mouseup', function () { dragging = false; });
      window.addEventListener('touchend', function () { dragging = false; });
      setFromX(ba.getBoundingClientRect().left + ba.getBoundingClientRect().width * 0.58);
    });

    /* ---- mobile sticky CTA ---- */
    var mobiles = document.querySelectorAll('.ninf .lp-mobilecta');
    if (mobiles.length) {
      var onScroll = function () {
        var show = window.scrollY > window.innerHeight * 0.9;
        mobiles.forEach(function (m) { m.classList.toggle('is-show', show); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
